import React, { FC } from 'react';
import { Container, Label, Select } from './styles';
import { BaseSelectProps, Props } from './types';

// TODO: TFR-48 make separate component
export const BaseFormSelect: FC<BaseSelectProps> = ({
  name,
  value,
  options,
  className,
  label,
  disabled,
  ...props
}) => {
  return (
    <Container className={className}>
      {label && (
        <Label as="label" $disabled={disabled} htmlFor={name}>
          {label}
        </Label>
      )}
      <Select
        options={options}
        currentValue={value}
        disabled={disabled}
        name={name}
        {...props}
      />
    </Container>
  );
};

const FormSelect: FC<Props> = ({
  name,
  value,
  options,
  className,
  label,
  disabled,
  ...props
}) => {
  return (
    <Container className={className}>
      {label && (
        <Label as="label" $disabled={disabled} htmlFor={name}>
          {label}
        </Label>
      )}
      <Select
        options={options}
        currentValue={value}
        disabled={disabled}
        name={name}
        {...props}
      />
    </Container>
  );
};

export default FormSelect;

// TODO: TFR-29 add stories to component
